import React from 'react';
import Icon from '../../../../../../muiComponents/Icon';
import Image from '../../../../../components/Image';

interface BrowserTabProps {
    title: string;
    src?: string;
}
const BrowserTab = ({ title, src }: BrowserTabProps) => {
    return (
        <div>
            <div className='favicon-browser-tab' role='tab' aria-label={title}>
                <span className='favicon-browser-tab__icon' aria-hidden='true'>
                    {src ? (
                        <Image
                            src={src}
                            alt='Favicon'
                            className='favicon-preview__image--browser-tab'
                        />
                    ) : (
                        <Icon iconName={'ImageOutlined'} />
                    )}
                </span>
                <span className='favicon-browser-tab__title'>{title}</span>
                <span className='favicon-browser-tab__close' aria-hidden='true'>
                    <Icon iconName='Close' />
                </span>
            </div>
            <div className='favicon-browser-tab__line' aria-hidden='true' />
        </div>
    );
};

export default BrowserTab;
